import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConstants } from '../common/global-constants';
import { SharedService } from './shared.service';
const apiUrl = GlobalConstants.apiURL

@Injectable({
  providedIn: 'root'
})
export class InsuranceService {

  constructor(private http: HttpClient, private sharedapi: SharedService) { }

  getAllInsCompany(pageno,limit,qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'ins-company-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader});
  }

  gelInsCompanyList()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-ins-company-list',{headers:webheader});
  }

  getInsCompany(tpaId)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-ins-company/'+tpaId,{headers:webheader});
  }

  addInsCompany(data){
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-ins-company',data,{headers:webheader})
  }

  updateInsCompany(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.patch(apiUrl+'update-ins-company',data,{headers:webheader})
  }

  updateInsCompanyStatus(data)
  {
    let webheader = this.sharedapi.getHeaders();
      return this.http.patch(apiUrl+'update-ins-company-status',data,{headers:webheader})
  }
}
